/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./img-tag.vue?vue&type=template&id=7bc6d8b9&scoped=true&"
import script from "./img-tag.vue?vue&type=script&lang=ts&setup=true&"
export * from "./img-tag.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./img-tag.vue?vue&type=style&index=0&id=7bc6d8b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc6d8b9",
  null
  
)

export default component.exports